// A stationary wax grain for light, in the same diagonal direction as the
// plates. Applying it AFTER the soft light field breaks the radiance into
// pigment strokes; blurring this mask would turn it back into an airbrush.
export default function CrayonLightMask({ id, width = 1024, height = 1024, scale = 1 }) {
  return (
    <>
      <filter id={`${id}-tooth`} x="0" y="0" width="100%" height="100%" colorInterpolationFilters="sRGB">
        <feTurbulence type="fractalNoise" baseFrequency=".045 .28" numOctaves="3" seed="23" stitchTiles="stitch" />
        <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  2.8 0 0 0 -0.65" />
      </filter>
      <pattern id={`${id}-strokes`} width="128" height="128" patternUnits="userSpaceOnUse" patternTransform={`rotate(-38) scale(${scale})`}>
        <rect width="128" height="128" fill="white" filter={`url(#${id}-tooth)`} />
        <g stroke="white" fill="none" strokeLinecap="round" opacity=".25">
          <path d="M-8 9l27 -1m7 0l51 1m9 0l49 -2M5 32l39 1m9 -2l60 1M-6 58l42 -2m11 1l30 1m11 -2l49 1M14 89l51 -1m12 2l39 -2M-5 116l21 1m9 -2l58 1m11 0l38 -1" strokeWidth="1.8" />
          <path d="M18 19l43 1m8 -1l40 1M-8 72l29 -1m11 2l58 -2m9 1l30 -1M2 102l54 -1m14 2l28 -1" strokeWidth="1" />
        </g>
      </pattern>
      <mask id={id} maskUnits="userSpaceOnUse" x="0" y="0" width={width} height={height} style={{ maskType: 'alpha' }}>
        <rect width={width} height={height} fill={`url(#${id}-strokes)`} />
      </mask>
    </>
  );
}
